import React, { useState } from 'react';
import { 
  Modal, 
  Button, 
  Text, 
  Group, 
  Stack, 
  Paper, 
  Divider, 
  Badge, 
  NumberFormatter,
  Grid,
  Title,
  Input,
  TextInput,
  Anchor
} from '@mantine/core';
import { Controller, useForm } from 'react-hook-form';
import { RHFSelect, RHFTextInput } from './FormComponents';
import images from "react-payment-inputs/images";
import { usePaymentInputs } from 'react-payment-inputs';
import axios from 'axios';
import base_url from '../../api/bootapi';
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';


export function BillingModal({ groupData,combinedPaymentId,fetchEnquiryData, opened, onClose,setBackdropOpen }) {
  

      const { control, handleSubmit, watch, setValue, reset, formState: { errors } ,setError} = useForm({
          defaultValues: {
             
              billing_zip:'',
              payment_method: "Card"
          }
      });
  
   const [cardDetails, setCardDetails] = useState({
          card_number: null,
          card_expiry_year: null,
          card_cvv: null,
      });
  
      const { wrapperProps, getCardImageProps, getCardNumberProps, getExpiryDateProps, getCVCProps } = usePaymentInputs();
  
  const grandTotalPending = groupData.reduce(
    (sum, item) => sum + parseFloat(item.pending_amount || 0), 
    0
  );

  
  const formatCurrency = (value) => (
    <NumberFormatter prefix="$" value={parseFloat(value)} thousandSeparator decimalScale={2} fixedDecimalScale />
  );

  const onSubmit = (data) => {
    console.log("Billing Data=======> ", data);

    const expiryValue = data.card_expiry; 

    if (expiryValue) {
      
      const cleanValue = expiryValue.replace(/\s/g, '');
    
     
      const regex = /^(0[1-9]|1[0-2])\/([0-9]{2})$/;
      if (!regex.test(cleanValue)) {
        setError("card_expiry", {
          type: "manual",
          message: "Format must be MM / YY"
        });
        return; 
      }

      
      const [monthStr, yearStr] = cleanValue.split('/');
      const expiryMonth = parseInt(monthStr, 10);
      const expiryYear = 2000 + parseInt(yearStr, 10);

      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;

     
      if (expiryYear < currentYear) {
        setError("card_expiry", {
          type: "manual",
          message: "Year must be in the future"
        });
        return;
      }

      
      if (expiryYear === currentYear && expiryMonth < currentMonth) {
        setError("card_expiry", {
          type: "manual",
          message: "Card has already expired"
        });
        return;
      }

    }
    
    const recordsWithOpenBalance = groupData.filter((item) => parseFloat(item.pending_amount) > 0)
      .map((item) => ({ id: item.id }));
    
    const [monthStr, yearStr] = expiryValue.split('/');

    const formData = new FormData();
    const requestData = {
      combined_payment_id: combinedPaymentId,
      payment_method: data.payment_method,
      card_number: data.card_number,
      card_cvv: data.card_cvv,
      card_expiry_month: monthStr?.trim(),
      card_expiry_year: yearStr?.trim(),
      billing_zip: data.billing_zip,
      items:recordsWithOpenBalance
      
    }

    formData.append("data", JSON.stringify(requestData));

    
    onClose()
   
     setBackdropOpen(true);
      axios
      .post(
        `${base_url.api1}/tourapp/make_bulk_payment`,
        formData,
       
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setBackdropOpen(false);
           
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Payment Successful",
              showCloseButton: true,
              showConfirmButton: false,
            });
            fetchEnquiryData();
          } else {
            setBackdropOpen(false);
            
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Payment failed",
              showCloseButton: true,
              showConfirmButton: false,
            });
          }
        },
        (error) => {
          setBackdropOpen(false);
          
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            showConfirmButton: false,
            showCloseButton: true,
          });
        }
      );
  }

  
  const navigate = useNavigate();
  
  const closeModal = () => {
    reset();
    onClose()
  }


  return (
    <Modal 
      opened={opened} 
      onClose={closeModal} 
      title={<Text fw={700} size="xl">Group Billing Summary</Text>} 
      size="xl" 
      radius="md"
      overlayProps={{ blur: 3 }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>

      
      <Stack gap="md">
        {groupData.map((person) => {
         
          const inclusions = [];
          if (person.full_package) inclusions.push({ label: 'Full Package', cost: person.full_package_price });
          if (person.accommodation_only) inclusions.push({ label: 'Accommodation Only', cost: person.accommodation_only_price });
          if (person.single_room_cost_only) inclusions.push({ label: 'Single Room Cost', cost: person.single_room_cost });
          if (person.other_cost_included) inclusions.push({ label: 'Other Costs', cost: person.other_cost });
          if (person.insurance) inclusions.push({ label: 'Insurance', cost: person.insurance_price });

          const isPaid = parseFloat(person.pending_amount) === 0;

          return (
            <Paper key={person.id} withBorder p="md" radius="md" shadow="sm">
            
              <Group justify="space-between" mb="sm">
                <Text fw={600} size="lg">
                  {person.first_name} {person.last_name}
                </Text>
                {/* <Badge color={isPaid ? 'green' : 'orange'} variant="light">
                  {isPaid ? 'Paid in Full' : 'Payment Pending'}
                </Badge> */}
                
                {/* <Anchor
      component={Link} 
      to={`/view-enquiry-status/${person.id}`} 
      size="sm" 
      fw={500}
      underline="hover"
    >
      View Enquiry
    </Anchor> */}
                
                <Badge 
      color="blue" 
      variant="filled"
      style={{ cursor: 'pointer' }}
      onClick={() => {
        onClose(); 
        navigate(`/view-enquiry-status/${person.id}`); 
      }}
    >
      View Enquiry
    </Badge>
              </Group>

             
              <Stack gap="xs" mt="md">
                {inclusions.map((item, idx) => (
                  <Group key={idx} justify="space-between">
                    <Text c="dimmed" size="sm">{item.label}</Text>
                    <Text size="sm" fw={500}>{formatCurrency(item.cost)}</Text>
                  </Group>
                ))}
              </Stack>

              <Divider my="sm" variant="dashed" />

             
              <Stack gap={4}>
                <Group justify="space-between">
                  <Text size="sm" fw={500}>Total Price</Text>
                  <Text size="sm" fw={600}>{formatCurrency(person.total_price)}</Text>
                </Group>
                <Group justify="space-between">
                  <Text size="sm" c="red.6" fw={600}>Open Balance</Text>
                  <Text size="sm" c="red.6" fw={600}>{formatCurrency(person.pending_amount)}</Text>
                </Group>
              </Stack>
            </Paper>
          );
        })}

      
       <Paper withBorder p="md" radius="md" bg="blue.0" mt="sm">
  <Stack gap="xs">
   
    <Group justify="space-between">
      <Text size="sm" c="blue.8">Total Open Balance</Text>
      <Text fw={600} size="sm" c="blue.9">
        {formatCurrency(grandTotalPending)}
      </Text>
    </Group>

   
    <Group justify="space-between">
      <Text size="sm" c="blue.8">Credit Card Fee (3%)</Text>
      <Text fw={600} size="sm" c="blue.9">
        {formatCurrency(grandTotalPending * 0.03)}
      </Text>
    </Group>

    <Divider my="xs" variant="dashed" color="blue.2" />

   
    <Group justify="space-between">
      <Stack gap={0}>
        <Text fw={700} size="lg" c="blue.9">Grand Total</Text>
        <Text size="xs" c="blue.8">Total open balance including card fee</Text>
      </Stack>
      <Text fw={800} size="xl" c="blue.9">
        {formatCurrency(grandTotalPending * 1.03)}
      </Text>
    </Group>
  </Stack>
</Paper>

        <Paper withBorder p="md" radius="md" bg="gray.0" mt="sm">
          <Grid >

                                              <Grid.Col span={{ base: 12, md: 4 }}>
                                                  <RHFSelect control={control} name="payment_method" label="Payment Method" data={["Card"]} />
          
                                              </Grid.Col>
          
          
          
          
                                          </Grid>
        <Title order={4} mt="lg">Credit Card Details</Title>
                                            <Divider my="sm" />
                                            <Grid>
                                                <Grid.Col span={{ base: 12, md: 4 }}>
                                                    <RHFTextInput control={control} name="card_holder_name" label="Name on Card" withAsterisk rules={{ required: "required" }} />
                                                </Grid.Col>
                                                
    <Grid.Col span={{ base: 12, md: 4 }}>
      <Controller
        name="card_number"
        control={control}
        rules={{ required: "required" }}
        render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
          
          const paymentProps = getCardNumberProps({
            onChange: (e) => {
              onChange(e.target.value); 
              setCardDetails?.(prev => ({ ...prev, card_number: e.target.value })); 
            },
            onBlur,
          });

          return (
            <Input.Wrapper label="Card Number" withAsterisk error={error?.message}>
              <TextInput
                ref={ref}
                value={value || ''}
                rightSection={<svg {...getCardImageProps({ images })} style={{ width: "24px", height: "auto" }} />}
                rightSectionWidth={40}
                styles={{ input: { height: '40px' } }}
                {...paymentProps} 
              />
            </Input.Wrapper>
          );
        }}
      />
    </Grid.Col>

    
    <Grid.Col span={{ base: 6, md: 2 }}>
      <Controller
        name="card_expiry"
        control={control}
        rules={{ required: "required" }}
        render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
          const paymentProps = getExpiryDateProps({
            onChange: (e) => {
              onChange(e.target.value);
              setCardDetails?.(prev => ({ ...prev, card_expiry_year: e.target.value }));
            },
            onBlur,
          });

          return (
            <Input.Wrapper label="Expiry Date" withAsterisk error={error?.message}>
              <TextInput 
                ref={ref}
                value={value || ''}
                styles={{ input: { height: '40px' } }} 
                {...paymentProps} 
              />
            </Input.Wrapper>
          );
        }}
      />
    </Grid.Col>

   
    <Grid.Col span={{ base: 6, md: 2 }}>
      <Controller
        name="card_cvv"
        control={control}
        rules={{ required: "Required" }}
        render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
          const paymentProps = getCVCProps({
            onChange: (e) => {
              onChange(e.target.value);
              setCardDetails?.(prev => ({ ...prev, card_cvv: e.target.value }));
            },
            onBlur,
          });

          return (
            <Input.Wrapper label="CVV" withAsterisk error={error?.message}>
              <TextInput 
                ref={ref}
                value={value || ''}
                styles={{ input: { height: '40px' } }} 
                {...paymentProps} 
              />
            </Input.Wrapper>
          );
        }}
      />
    </Grid.Col>
          </Grid>

          <Grid>
             <Grid.Col span={{ base: 12, md: 4 }}>
                                                    <RHFTextInput control={control} name="billing_zip" label="Billing Zip Code" withAsterisk rules={{ required: "Required" }} />
                                                </Grid.Col>
          </Grid>
          
          </Paper>
        
       
        <Group justify='flex-end' gap={'sm'} mt={'md'}>
 <Button variant='outline' type='button' size="md" radius="md" onClick={onClose}>
          Close
          </Button>
          
           <Button  size="md"  radius="md" type='submit'>
          Pay Now
        </Button>
        </Group>
       
        </Stack>
        
        </form>
    </Modal>
  );
}